export default __webpack_public_path__ + "static/media/cips.db1d3185.png";